import algoliaApi from 'apis/algolia'
import { getProductCategoryUrl } from 'lib/category'
import { slugifyTitle } from 'lib/slugify'

const { ALGOLIA_APPLICATION_ID, ALGOLIA_ENV, ALGOLIA_SEARCH_API, APP_ENV } = process.env
const applicationId: string = ALGOLIA_APPLICATION_ID || ''
const searchApi: string = ALGOLIA_SEARCH_API || ''
const algoliaEnv: string = ALGOLIA_ENV || APP_ENV || 'production'
const searchIndice: string = `${algoliaEnv}_all_artworks`
export const config: Record<string, any> = {
  applicationId,
  searchApi,
  searchIndice,
}
const RESULTS = 29

const getArtworkLinks = (data): Record<string, any> => {
  const {
    artwork_title: artworkTitle,
    legacy_art_id: legacyArtId,
    artId,
    category,
    id_user: idUser,
    original_status: originalStatus,
    prints_availability: printsAvailability,
  } = data || {}
  const hasPrints = printsAvailability !== 'none'
  const title = slugifyTitle(`${getProductCategoryUrl(category)}-${artworkTitle}`)
  const path = `${title}/${idUser}/${legacyArtId || artId}`
  const originalUrl = `/art/${path}/view`
  const printUrl = `/print/${path}/view`
  let productUrl = originalUrl

  if (hasPrints && originalStatus === 'unavail') {
    productUrl = printUrl
  }

  return {
    originalUrl,
    printUrl,
    productUrl,
  }
}

export function whitelistAlgoliaArtworkData(data: Record<string, any>): Record<string, any> {
  const artistName =
    data.first_name && data.first_name ? `${data.first_name} ${data.last_name}` : ''
  const { originalUrl, printUrl, productUrl } = getArtworkLinks(data)
  return {
    api: 'algolia',
    artistId: data.id_user,
    artistName,
    artworkId: data.artId,
    category: data.category,
    baseImageUrl: data.image_url.replace(/-[\d].jpg$/, ''),
    // strip `-6.jpg`
    country: data.country,
    dimensions: {
      width: data.width,
      height: data.height,
      depth: data.depth,
    },
    minPrintPrice: Number(data.min_print_price) || '',
    originalStatus: data.original_status,
    originalListPrices: data.geo_prices || {},
    printsAvailability: data.prints_availability,
    productPage: !data.price && data.has_prints ? printUrl : originalUrl,
    productUrl,
    materials: data.materials || [],
    mediums: data.mediums || [],
    profileUrl: data.profile_url,
    sku: data.sku,
    title: data.artwork_title,
  }
}
export const fetchSeeMoreArtworks = async ({ callBack }: Record<string, any>): Promise<void> => {
  // Algolia Setup
  const algoliaOptions = {
    ...config,
    page: 0,
    hitsPerPage: RESULTS,
    isBotTraffic: true, // Used to tell ALGOLIA if they should TRACK/ANALYTICS ( turn OFF in PDP )
  }
  const artistArtworksRaw = await algoliaApi({ ...algoliaOptions })
  // Fetch results for query
  const artistArtworks = artistArtworksRaw.hits.map((hit) => whitelistAlgoliaArtworkData(hit))
  callBack(artistArtworks)
}
